import { ComponentProps } from 'react';
import Spin from 'antd/es/spin';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import clsx from 'clsx';

import './OpSpin.scss';

interface OpSpinProps extends ComponentProps<typeof Spin> {
  centered?: boolean;
}

export const OpSpin = ({ className, centered, ...spinProps }: OpSpinProps) => {
  return (
    <Spin
      className={clsx('op-spin', className, { 'op-spin--centered': centered })}
      indicator={<LoadingOutlined />}
      size="large"
      {...spinProps}
    />
  );
};
